<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-bind:style="{ width: width }" @click.stop>
          <button class="modal-default-button" @click="closeModal" id="modal5">
            X
          </button>
          <div class="modal-header">
            <h3>{{ title }}</h3>
          </div>
          <div class="modal-body">
            <component :is="component" :data="data" v-on:close="closeModal"></component>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import CompanyAddress from '../Dashboard/Views/Companies/Modal/Address'
  import CompanyContact from '../Dashboard/Views/Companies/Modal/Contact'
  import CompanyNote from '../Dashboard/Views/Companies/Modal/CompanyNote'
  import ConfirmDelete from '@/components/GeneralViews/Modal/ConfirmDelete.vue'
  import Constants from 'src/utilities/constants'
  import Street from '../Dashboard/Views/Streets/Modal/Street'
  import StreetResults from '../Dashboard/Views/Streets/Modal/StreetResults'
  import UploadForms from '../Dashboard/Views/Files/Modal/UploadForms'
  import NoClientOrBuilder from '@/components/Dashboard/Views/Jobs/Modal/NoClientOrBuilder'
  import NoCommunityResultsFound from '@/components/Dashboard/Views/Communities/Modal/NoResultsFound'
  import Community from '@/components/Dashboard/Views/Communities/Modal/Community'
  import {focusTrap} from '@/utilities/utils'

  export default {
    props: ['title', 'component', 'data', 'width'],
    components: {
      CompanyAddress,
      CompanyContact,
      CompanyNote,
      ConfirmDelete,
      Street,
      StreetResults,
      Community, // Potential for three more modal levels to open from here
      NoClientOrBuilder,
      NoCommunityResultsFound,
      UploadForms
    },
    methods: {
      closeModal() {
        this.$emit('close')
      }
    },
    mounted() {
      document.addEventListener('keydown', (e) => {
        if (e.keyCode === Constants.ESCAPE_KEY) {
          this.$emit('close')
        }
      })
      focusTrap('modal5', this.component)
      this.$store.set('modalTracker/modal5', this.component)
    },
    destroyed() {
      this.$store.set('modalTracker/modal5', null)
    },
    watch: {
      'component': {
        handler: function () {
          this.$store.set('modalTracker/modal5', this.component)
        }
      }
    }
  }
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 2004;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    z-index: 2005;
  }

  .modal-container {
    width: 74%;
    max-height: calc(100vh - 50px);
    max-width: calc(100vw - 50px);
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    z-index: 999;
  }

  .modal-header, .modal-footer {
    border: none;
    padding: 0;
  }
  .modal-header h3 {
    margin: 0;
    padding: 0;
  }

  .modal-body {
    padding: 0;
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
    z-index: 100000;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="Modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the Modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
